import { Button, DialogContent } from "@material-ui/core";
import Modal from "Components/Modal/Modal";
import ModalTitle from "Components/Modal/ModalTitle";
import { useIsBrowserOrIpadOs } from "Helpers/PlatformHelper";
import { useTranslation } from "Providers/TranslationProvider";
import Lottie from "lottie-react-web";
import React, { FC } from "react";
import { TUTORIAL_TYPE_RECORD } from "./consts/TUTORIAL_TYPE_RECORD";
import { useTutorialModal } from "./hooks/useTutorialModal";

const TutorialModal: FC = () => {
	const { t } = useTranslation();
	const isBrowserOrIpadOs = useIsBrowserOrIpadOs();
	const tutorialType = useTutorialModal((state) => state.item);

	const isModalOpen = useTutorialModal((state) => state.isOpen);

	if (!tutorialType) {
		return null;
	}

	const lottie = TUTORIAL_TYPE_RECORD[tutorialType].lottie;

	if (isModalOpen && isBrowserOrIpadOs) {
		return (
			<Modal modalController={useTutorialModal.getState()} isCloseDisabled>
				<ModalTitle title={t("Tutorial_Common_Title")}>
					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							useTutorialModal.getState().close();
						}}
					>
						{t("Tutorial_Common_Cta_Ok")}
					</Button>
				</ModalTitle>
				<DialogContent>
					{t(TUTORIAL_TYPE_RECORD[tutorialType].message)}
					<Lottie options={{ animationData: lottie }} />
				</DialogContent>
			</Modal>
		);
	} else {
		return null;
	}
};

export default TutorialModal;
